module.exports = __webpack_public_path__ + "static/media/pastordavid.7b7a907c.jpg";